<template>
<ion-select 
    multiple="false" 
    :value="value.value"
    @ionChange="value.value = $event.target.value">
    <ion-select-option
        :value="option"
        v-for="(option, index) in field.options.flat()"
        v-bind:key="index">{{option}}</ion-select-option>
</ion-select>
</template>

<script>
import Field from "../models/Field";
import Value from "../models/Value";
export default {
  name: "field-select",
  components: {},
  props: ["field", "value"],
}
</script>

<style scoped>

</style>